<template>
	<CreationWizardStepWrapper class="display-flex flex-wrap">
		<template #header>
			<ChooseCredentialsHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="display-flex flex-1 flex-wrap height-100">
			<div class="flex-col-12 display-flex flex-wrap">
				<div class="flex-col-9">
					<div class="display-flex flex-wrap pb-3">
						<div class="dropdown-title flex-col-12">Connect your account</div>
						<div class="dropdown-secondary-title flex-col-12 display-flex" v-if="serviceSupportWorkspace">
							<div class="pr-1">This will also determine the workspace the feature will appear in</div>
							<AppInfoTooltipIcon :text="tooltipText" />
						</div>
					</div>
					<ChooseCredentialsProfileSelectorDataProvider
						:appId="selectedAppId"
						:profileId="selectedCredentialsId"
						:showWrongServiceWorkspaceMessage="credsServiceWorkspaceIsWrong"
						@select-profile="selectProfile"
						:selectedProjectId="selectedProjectId"
					/>
				</div>
			</div>
			<div class="flex-1 flex-center--end">
				<OutlinedButton class="mr-2" v-if="canSkipCredentials" @click="nextStep">Skip</OutlinedButton>
				<PrimaryButton @click="nextStep" :disabled="isContinueWithCredsButtonDisabled">Continue</PrimaryButton>
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';
import ChooseCredentialsHeader from './ChooseCredentialsHeader.vue';
import ChooseCredentialsProfileSelectorDataProvider from './ChooseCredentialsProfileSelectorDataProvider.vue';
import props from './ChooseCredentials.props';
import AppService from '@/utils/AppService';
import { pluralize } from '@/utils/language-service';

export default {
	name: 'ChooseCredentials',
	mixins: [WizardStepMixin],
	props,
	components: { ChooseCredentialsHeader, ChooseCredentialsProfileSelectorDataProvider },
	computed: {
		selectedCredentialsId: {
			get() {
				return this.selectedCredentialsConfiguration.id;
			},
			set(credentialsId) {
				this.updateState({
					key: 'selectedCredentialsConfiguration',
					value: { ...this.selectedCredentialsConfiguration, id: credentialsId },
				});
			},
		},
		isContinueWithCredsButtonDisabled() {
			return this.credsServiceWorkspaceIsWrong || !this.selectedCredentialsId;
		},
		tooltipText() {
			const workspaceResourceTitle = AppService.getServiceWorkspaceResourceTitle(this.selectedApp);
			return `Ply supports multiple ${pluralize(workspaceResourceTitle)} for ${
				this.selectedApp.service_name
			}.<br/>Every ${workspaceResourceTitle} has it's own add-ons and one</br>add-on can only appear in one ${workspaceResourceTitle},<br/>which is determined by this connection.`;
		},
		serviceSupportWorkspace() {
			return AppService.doesAppSupportAccountWorkspaces(this.selectedApp);
		},
		canSkipCredentials() {
			return AppService.canSkipPlacementCredentials(this.selectedApp);
		},
	},
	methods: {
		selectProfile(credentialsId) {
			this.selectedCredentialsId = credentialsId;
		},
	},
};
</script>

<style lang="scss" scoped>
.dropdown-title {
	font-size: 12px;
	font-weight: normal;
}
.dropdown-secondary-title {
	font-size: 10px;
	font-weight: 200;
}
</style>
